const userReducerDefaultState = {
    isLoading:false
};
export default (state = userReducerDefaultState , action) => {
    switch(action.type){
        case "USER_LOGIN":
            return{
                ...state,
                ...action.userInfo,
            };
        case "USER_LOGOUT":
           
            return{
                userReducerDefaultState
            };
        case "APP_LOADING":
            return{
                ...state,
                isLoading:action.isLoading
            };
        default:
            return state 
            
    }
}